/**
 * Live-черновик формулы / выделения / клавиш через Yjs awareness.
 */

const COLORS = [
  '#38bdf8', '#f472b6', '#a78bfa', '#34d399', '#fbbf24', '#fb7185', '#2dd4bf',
];

export function colorForClientId(clientId) {
  const n = Number(clientId) || 0;
  return COLORS[Math.abs(n) % COLORS.length];
}

/** Локальный фрагмент awareness для таблицы. */
export function buildSheetAwarenessPayload({
  dataKey,
  active,
  sel = null,
  ranges = null,
  editing,
  pointTo = null,
  ants = null,
  keys = null,
  name = '',
}) {
  const payload = {
    dataKey: String(dataKey || 'data'),
    active: active ? { row: active.row, col: active.col } : null,
    ranges: Array.isArray(ranges) && ranges.length
      ? ranges.map((r) => ({
        r0: r.r0, r1: r.r1, c0: r.c0, c1: r.c1,
      }))
      : null,
    sel: null,
    editing: null,
    ants: null,
    keys: Array.isArray(keys) ? keys.slice(0, 8) : [],
  };
  // обратная совместимость: один sel
  if (payload.ranges?.length) {
    const last = payload.ranges[payload.ranges.length - 1];
    payload.sel = { ...last };
  } else if (sel) {
    payload.sel = {
      r0: sel.r0, r1: sel.r1, c0: sel.c0, c1: sel.c1,
    };
    payload.ranges = [payload.sel];
  }
  if (editing) {
    const ptRange = pointTo && pointTo.r0 != null
      ? {
        r0: pointTo.r0,
        r1: pointTo.r1 ?? pointTo.r0,
        c0: pointTo.c0,
        c1: pointTo.c1 ?? pointTo.c0,
      }
      : null;
    payload.editing = {
      row: editing.row,
      col: editing.col,
      draft: String(editing.draft ?? ''),
      caret: Number.isFinite(editing.caret) ? editing.caret : String(editing.draft ?? '').length,
      pointTo: pointTo && Number.isFinite(pointTo.row) && Number.isFinite(pointTo.col)
        ? { row: pointTo.row, col: pointTo.col }
        : null,
      pointRange: ptRange,
    };
  }
  if (ants && Number.isFinite(ants.r0)) {
    payload.ants = {
      r0: ants.r0, r1: ants.r1, c0: ants.c0, c1: ants.c1,
    };
  }
  if (name) payload.name = String(name);
  return payload;
}

export function setLocalSheetAwareness(awareness, sheetPayload) {
  if (!awareness) return;
  const prev = awareness.getLocalState() || {};
  awareness.setLocalState({
    ...prev,
    sheet: sheetPayload || null,
  });
}

export function clearLocalSheetAwareness(awareness) {
  if (!awareness) return;
  const prev = awareness.getLocalState() || {};
  if (!prev.sheet) return;
  const next = { ...prev };
  delete next.sheet;
  awareness.setLocalState(next);
}

/**
 * Чужие черновики/выделения по dataKey.
 * @returns {{ clientId: number, color: string, name: string, sheet: object }[]}
 */
export function listRemoteSheetStates(awareness, dataKey) {
  if (!awareness) return [];
  const key = String(dataKey || 'data');
  const localId = awareness.clientID;
  const out = [];
  awareness.getStates().forEach((state, clientId) => {
    if (clientId === localId) return;
    const sheet = state?.sheet;
    if (!sheet || sheet.dataKey !== key) return;
    out.push({
      clientId,
      color: colorForClientId(clientId),
      name: String(sheet.name || state?.user?.name || ''),
      sheet,
    });
  });
  return out;
}

/** Кто редактирует клетку (кроме себя). */
export function remoteEditorOnCell(remotes, row, col) {
  for (const r of remotes) {
    const ed = r.sheet?.editing;
    if (ed && ed.row === row && ed.col === col) return r;
  }
  return null;
}

export function remoteRangesOnCell(remotes, row, col) {
  const hits = [];
  for (const r of remotes) {
    const ranges = r.sheet?.ranges
      || (r.sheet?.sel ? [r.sheet.sel] : []);
    for (const sel of ranges) {
      if (!sel) continue;
      const r0 = Math.min(sel.r0, sel.r1);
      const r1 = Math.max(sel.r0, sel.r1);
      const c0 = Math.min(sel.c0, sel.c1);
      const c1 = Math.max(sel.c0, sel.c1);
      if (row >= r0 && row <= r1 && col >= c0 && col <= c1) {
        hits.push({ ...r, range: { r0, r1, c0, c1 } });
        break;
      }
    }
  }
  return hits;
}
